import * as Zod from 'zod';

export const fileValidator = Zod.object({
    __typename: Zod.literal('File'),
    id: Zod.string(),
    name: Zod.string().nullable().optional(),
    url: Zod.string().nullable().optional(),
});
